import { createFileRoute } from '@tanstack/react-router';
import { PortfolioHeader } from '../../components/PortfolioHeader/PortfolioHeader';

export const Route = createFileRoute('/portfolio/funding')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <PortfolioHeader title="Funding History" />
      <p className="p-4">Coming soon</p>
    </div>
  );
}
